import { useState } from 'react';
import { FormControl, FormLabel, Grid, TextField } from '@mui/material';

export default function Number(props) {
    const [value, setValue] = useState(props.value ?? '');
    const [minValue, setMinValue] = useState(props.min ?? '');
    const [maxValue, setMaxValue] = useState(props.max ?? '');

    const handleChange = (event, field) => {
        const regex = /^[0-9\b]+$/;

        if (event.target.value === '' || regex.test(event.target.value)) {
            switch (field) {
                case 'min':
                    setMinValue(event.target.value);
                    props.onChange(props.minName, event.target.value);
                    break;
                case 'max':
                    setMaxValue(event.target.value);
                    props.onChange(props.maxName, event.target.value);
                    break;
                default:
                    setValue(event.target.value);
                    props.onChange(props.minName, event.target.value);
                    props.onChange(props.maxName, event.target.value);
                    props.onChange(props.name, event.target.value);
            }
        }
    };

    return (
        <FormControl fullWidth>
            <FormLabel variant="list-filter">{props.label}</FormLabel>
            {props.range ? (
                <Grid container spacing={4}>
                    <Grid item xs={6}>
                        <TextField label={'From'} value={minValue} onChange={e => handleChange(e, 'min')} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField label={'To'} value={maxValue} onChange={e => handleChange(e, 'max')} />
                    </Grid>
                </Grid>
            ) : (
                <TextField placeholder={props.placeholder} value={value} onChange={e => handleChange(e, 'value')} />
            )}
        </FormControl>
    );
}
